import { render, staticRenderFns } from "./ModalAlertConfirm.vue?vue&type=template&id=37fd62ca&scoped=true&"
import script from "./ModalAlertConfirm.vue?vue&type=script&lang=js&"
export * from "./ModalAlertConfirm.vue?vue&type=script&lang=js&"
import style0 from "./ModalAlertConfirm.vue?vue&type=style&index=0&id=37fd62ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fd62ca",
  null
  
)

export default component.exports